/* ============
 * Mutations for the panoramas module
 * ============
 *
 * The mutations that are available on the
 * panoramas module.
 */

import { LOAD } from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [LOAD](state, panoramas) {
    state.panoramas = panoramas.data;
  },
};
